import { useState, useRef, useEffect } from 'react';

const useXSearchMultiSelect = ({ onSearch, value, onChange }) => {
    const [inputValue, setInputValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleChange = (val) => {
        setInputValue(val);
        onSearch(val);
        setShowDropdown(true);
    };

    const openDropdown = () => setShowDropdown(true);

    const toggleItem = ({ item }) => {
        const current = Array.isArray(value) ? value : [];
        const alreadySelected = current.some((v) => v._id === item._id);
        const next = alreadySelected
            ? current.filter((v) => v._id !== item._id)
            : [...current, item];
        onChange(next);
    };

    const removeItem = ({ item }) => {
        const current = Array.isArray(value) ? value : [];
        onChange(current.filter((v) => v._id !== item._id));
    };

    const handleKeyDown = ({ e, items }) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (!items || items.length === 0) return;
        toggleItem({ item: items[0] });
        setInputValue('');
        onSearch('');
        setShowDropdown(false);
    };

    return { inputValue, showDropdown, dropdownRef, handleChange, openDropdown, toggleItem, removeItem, handleKeyDown };
};

export default useXSearchMultiSelect;
